"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlowLine = void 0;
const class_variance_authority_1 = require("class-variance-authority");
const classnames_1 = __importDefault(require("classnames"));
const glowLineVariants = {
    red: 'shadow-red-glow',
    green: 'shadow-green-glow',
    purple: 'shadow-purple-glow',
};
const glowLineVariant = (0, class_variance_authority_1.cva)('h-0.5 rounded bg-white', {
    variants: {
        variant: glowLineVariants,
    },
});
const GlowLine = ({ className, variant }) => {
    return (<div className={(0, classnames_1.default)(glowLineVariant({ variant }), className)}/>);
};
exports.GlowLine = GlowLine;
